import React from "react";
import Lottie from "react-lottie-player";
import loaderanimation from "./images/LoaderAnimation.json";

const LoaderAnimationMedium = ({ loadingTxt = "" }) => {
  return (
    <div className="loadingindicatormedium">
      <Lottie
        loop
        animationData={loaderanimation}
        play
        style={{ width: 64, height: 64, marginBottom: 16 }}
      />
      <p className="loadingTxt">{loadingTxt}</p>
    </div>
  );
};

export default LoaderAnimationMedium;
